// PROD;
const vars = {
  firebaseApiKey: "AIzaSyCXZNPbGtOQqDg4lDKP5HcGpuvfcj0laVw",
  firebaseApiUrl: "https://europe-west1-comitty-79c84.cloudfunctions.net",
  woosmapPublicKey: "woos-0952c97d-1abb-3a64-8860-be2f95fd0253",
  woosmapPrivateKey: "cf0d09a6-071b-41dd-92b6-3feff8842349",
  hostname: "https://ticket.comitty.be",
  google_maps_api_key: "AIzaSyBAScK9yRor-TV9p_B-Gpo9IFUXLMts63c",
  google_translate_api_key: "AIzaSyB7I6sfwYoiASPuEtb4py4N9Ta6DWcl0A8",
  emailJsServiceId: "service_c8i7gyc",
  emailJsTemplateId: "template_bmpkuw6",
  emailJsTicketingTicketTemplateId: "template_3d92hqa",
  emailJsAccreditationTemplateId: "template_6xy5msq",
  emailJsTicketingBroadcastTemplateId: "template_dtca4or",
  emailJsPublicApiKey: "user_Io6hQDXLobAbA5jUwZICt",
  emailJsToEmail: "thomas@comitty.be",
  mapId: "4ef0b5e1c3bc40dbee0bfeae",
  ENABLE_MARKETPLACE: true,
};

// DEV;
// const vars = {
//   firebaseApiKey: "AIzaSyCXZNPbGtOQqDg4lDKP5HcGpuvfcj0laVw",
//   firebaseApiUrl: "https://europe-west1-comitty-79c84.cloudfunctions.net",
//   woosmapPublicKey: "woos-0952c97d-1abb-3a64-8860-be2f95fd0253",
//   woosmapPrivateKey: "cf0d09a6-071b-41dd-92b6-3feff8842349",
//   hostname: "http://localhost:3000",
//   google_maps_api_key: "AIzaSyBAScK9yRor-TV9p_B-Gpo9IFUXLMts63c",
//   google_translate_api_key: "AIzaSyB7I6sfwYoiASPuEtb4py4N9Ta6DWcl0A8",
//   emailJsServiceId: "service_c8i7gyc",
//   emailJsTemplateId: "template_bmpkuw6",
//   emailJsTicketingTicketTemplateId: "template_3d92hqa",
//   emailJsAccreditationTemplateId: "template_6xy5msq",
//   emailJsTicketingBroadcastTemplateId: "template_ticketing_broadcast",
//   emailJsPublicApiKey: "user_Io6hQDXLobAbA5jUwZICt",
//   emailJsToEmail: "thomas@comitty.be",
//   mapId: "4ef0b5e1c3bc40dbee0bfeae",
//   ENABLE_MARKETPLACE: true,
// };

export default vars;
